import type {
  ConfigurationOperation,
  FPlusTypeCheckingContext,
} from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'
import { createRequiredContext } from '@festina-life/ui/libs'

type FPlusTypeCheckingContextProps = {
  context: FPlusTypeCheckingContext
  currentOperation: Optional<ConfigurationOperation>
}

const [useFPlusTypeCheckingContext, Provider] =
  createRequiredContext<FPlusTypeCheckingContextProps>(
    'fplusTypeCheckingContext',
  )

export { Provider, useFPlusTypeCheckingContext }
